import React from "react";
import { motion } from "framer-motion";

const educationData = [
  {
    institution: "NED University of Engineering and Technology",
    degree: "Bachelor of Engineering - BE, Electronics Engineering",
    duration: "Oct 2020 - Oct 2024",
    cgpa: "3.282",
    logo: require('../assets/Education/1.jpg'), // keep your local path
  },
  {
    institution: "DJ Sindh Government Science College",
    degree: "FSC, Engineering",
    duration: "Apr 2017 - Apr 2019",
    grade: "A",
    logo: require('../assets/Education/2.png'), // keep your local path
  },
];

const EducationSection = () => {
  return (
    <section id="education" className="education-section text-gray-300 py-20 px-6">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold mb-12 text-white text-center">
          Education
        </h2>

        <div className="flex flex-col gap-6">
          {educationData.map((edu, index) => (
            <motion.div
              key={index}
              className="bg-black/70 p-4 md:p-6 rounded-xl border-2 border-transparent shadow-lg flex items-center gap-4"
              whileHover={{ scale: 1.02, boxShadow: "0 10px 25px rgba(0,0,0,0.5)" }}
              style={{
                borderImage: "linear-gradient(90deg, #00BFFF, #FF0000, #FFA500, #FFFFFF) 1"
              }}
            >
              <img
                src={edu.logo}
                alt={edu.institution}
                className="w-16 h-16 object-contain rounded-md"
              />
              <div className="flex-1">
                <h3 className="text-xl md:text-2xl font-semibold text-white">{edu.institution}</h3>
                <p className="text-gray-400 font-medium">{edu.degree}</p>
                <p className="text-gray-500 text-sm">
                  {edu.duration} {edu.cgpa ? `· CGPA: ${edu.cgpa}` : edu.grade ? `· Grade: ${edu.grade}` : ""}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EducationSection;
